import React, {useRef, useState} from 'react';
import {DateRangePicker, Range} from 'react-date-range';
import {TextField, Popover, Box, SxProps} from '@mui/material';
import {Control, Controller, FieldValues} from 'react-hook-form';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import './FormDateRange.css';
import {DateTime} from 'luxon';

interface Props {
  control: Control<FieldValues>;
  name: string;
  label?: string;
  required?: boolean;
  sx?: SxProps;
}

export const FormDateRange: React.FC<Props> = ({
  control,
  name,
  label,
  required,
  sx,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const open = Boolean(anchorEl);
  const inputRef = useRef<HTMLDivElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const formatDateRange = (range: Range) => {
    if (!range?.startDate || !range?.endDate) return '';
    return `${DateTime.fromJSDate(range.startDate).toFormat('MM/dd/yyyy')} - ${DateTime.fromJSDate(
      range.endDate,
    ).toFormat('MM/dd/yyyy')}`;
  };

  return (
    <Controller
      name={name}
      control={control}
      // defaultValue={{
      //   startDate: new Date(),
      //   endDate: new Date(),
      //   key: 'selection',
      // }}
      render={({field: {value, onChange}}) => (
        <Box ref={inputRef} sx={sx}>
          <TextField
            label={label}
            value={formatDateRange(value)}
            onClick={handleClick}
            required={required}
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}>
            <DateRangePicker
              ranges={[
                value ?? {
                  startDate: new Date(),
                  endDate: new Date(),
                  key: 'selection',
                },
              ]}
              onChange={item => {
                onChange(item.selection);
                if (item.selection.startDate && item.selection.endDate) {
                  // handleClose();
                }
              }}
              editableDateInputs={true}
              moveRangeOnFirstSelection={false}
              months={1}
              direction="vertical"
              showDateDisplay={false}
            />
          </Popover>
        </Box>
      )}
    />
  );
};

export default FormDateRange;
